const inputCls = "_086ib92t9n";

export { inputCls };
import "./TableCellText.style.linaria.module.css";
//# sourceMappingURL=TableCellText.style.js.map
